module.exports = __webpack_public_path__ + "img/Lobby_info_img.65dce621.jpg";